export default {
  currentProvider: (store) => {
    let selectedProvider = {};

    if (store.managedProviders && store.managedProviders.data) {
      store.managedProviders.data.find((provider) => {
        if (provider.id === store.selectedProvider) {
          selectedProvider = provider;
        }
      });
    }

    return selectedProvider;
  }
};
